/* Punartha: play homepage videos only while they are on screen.
   Pauses the founder-film and reels videos when scrolled out of view and
   resumes them when they return, to save network and battery on mobile.
   Progressive enhancement: the markup keeps native `autoplay`, so if this
   script or IntersectionObserver is unavailable the videos still play. */
(function () {
  if (window.__pthVideoInview) return;
  window.__pthVideoInview = true;

  function init() {
    if (!('IntersectionObserver' in window)) return;
    var videos = document.querySelectorAll('.pth-film__video, .pth-reels__video');
    if (!videos.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.paused) {
              var playing = video.play();
              if (playing && typeof playing.catch === 'function') {
                playing.catch(function () {});
              }
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.2 }
    );

    videos.forEach(function (video) {
      // Muted + inline is required for programmatic play on mobile.
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      // Hand play/pause control to the observer instead of the browser so
      // off-screen videos never start in the first place.
      video.removeAttribute('autoplay');
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
